import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import {
  ConfiguracaoAtualizar,
  ConfiguracaoIncluir,
  ConfiguracoesFiltrar,
} from "../../../../../services/Fiscal.Service";
import {
  ConfiguracaoCadastroDto,
  configuracaoOptions,
  EConfiguracaoTipo,
  SistemaCadastroSchema,
} from "./SistemaCadastro.Dto";
import { showToast } from "src/componentes";
import { ConsultarUsuario } from "src/hook/Consulta/ConsultaUsuario.Module";
import { UsuarioGestaoBuscarPorId } from "src/services/Identity.Service";

const SistemaCadastroCode = () => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [operacaoInclusao, setOperacaoInclusao] = useState(true);
  const navigate = useNavigate();
  const id = searchParams.get("id");

  const form = useForm<ConfiguracaoCadastroDto>({
    resolver: yupResolver(SistemaCadastroSchema),
  });

  const subModulo = form.watch("subModulo");

  const consultarUsuario = ConsultarUsuario();

  useEffect(() => {
    const controller = new AbortController();
    const load = async () => {
      setLoading(true);
      try {
        if (id) {
          const response = await ConfiguracoesFiltrar({ id: Number(id) });
          if (response.data.success) {
            const data = response.data.data[0] as ConfiguracaoCadastroDto;
            if (
              data.tipoConfiguracao === EConfiguracaoTipo.Serie &&
              data.usuarioId
            ) {
              const usuarioResponse = await UsuarioGestaoBuscarPorId(
                data.usuarioId.toString()
              );
              if (usuarioResponse.data.success) {
                const usuarioData = usuarioResponse.data.data;
                data.usuarioNome = usuarioData.nome;
              } else {
                showToast({
                  message: "Ocorreu erro ao carregar Usuário",
                  title: "Erro",
                  variant: "Danger",
                });
              }
            }

            if (data) {
              form.reset(data);
              setOperacaoInclusao(false);
            } else {
              showToast({
                message: "Configuração não encontrada.",
                title: "Aviso",
                variant: "Warning",
              });
              setOperacaoInclusao(true);
              setLoading(false);
              return;
            }
          } else {
            MapearErrosServidor(response.data.notifications, showToast);
          }
        } else {
          setOperacaoInclusao(true);
        }
      } catch (error: any) {
        showToast({
          message: "Erro ao buscar configuração.",
          title: "Erro",
          variant: "Danger",
        });
      } finally {
        setLoading(false);
      }
    };
    load();
    return () => controller.abort();
  }, []);

  const onSubmit = async (data: ConfiguracaoCadastroDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (operacaoInclusao) {
        await ConfiguracaoIncluir({
          subModulo: Number(data.subModulo),
          tipoConfiguracao: Number(data.tipoConfiguracao),
          configuracaoValor: data.configuracaoValor ?? "",
          usuarioId: data.usuarioId ? Number(data.usuarioId) : undefined,
        }).then((response) => {
          if (response.data.success) {
            navigate("/configuracao/sistema");
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError
            );
            MapearErrosServidor(response.data.notifications, showToast);
          }
        });
      } else {
        await ConfiguracaoAtualizar({
          id: Number(id),
          subModulo: Number(data.subModulo),
          tipoConfiguracao: Number(data.tipoConfiguracao),
          configuracaoValor: data.configuracaoValor ?? "",
          usuarioId: data.usuarioId ? Number(data.usuarioId) : undefined,
        }).then((response) => {
          if (response.data.success) {
            navigate("/configuracao/sistema");
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError
            );
            MapearErrosServidor(response.data.notifications, showToast);
          }
        });
      }
    } catch (error) {
      showToast({
        message: "Erro ao salvar configuração.",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    onSubmit,
    form,
    configuracaoOptions,
    subModulo,
    consultarUsuario,
  };
};

export default SistemaCadastroCode;
